import { render, staticRenderFns } from "./avatarSmall.vue?vue&type=template&id=1dc98329&"
import script from "./avatarSmall.vue?vue&type=script&lang=js&"
export * from "./avatarSmall.vue?vue&type=script&lang=js&"
import style0 from "./avatarSmall.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports